var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotesDiary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0208 0.5H2.83333C2.2808 0.5 1.75089 0.719493 1.36019 1.11019C0.969493 1.5009 0.75 2.0308 0.75 2.58333V23.4167C0.75 23.9692 0.969493 24.4991 1.36019 24.8898C1.75089 25.2805 2.2808 25.5 2.83333 25.5H20.0208C20.5734 25.5 21.1033 25.2805 21.494 24.8898C21.8847 24.4991 22.1042 23.9692 22.1042 23.4167V2.58333C22.1042 2.0308 21.8847 1.5009 21.494 1.11019C21.1033 0.719493 20.5734 0.5 20.0208 0.5ZM20.0208 22.8958C20.0208 23.034 19.966 23.1664 19.8683 23.2641C19.7706 23.3618 19.6381 23.4167 19.5 23.4167H6.47917C6.34103 23.4167 6.20856 23.3618 6.11088 23.2641C6.01321 23.1664 5.95833 23.034 5.95833 22.8958V3.10417C5.95833 2.96603 6.01321 2.83356 6.11088 2.73588C6.20856 2.63821 6.34103 2.58333 6.47917 2.58333H19.5C19.6381 2.58333 19.7706 2.63821 19.8683 2.73588C19.966 2.83356 20.0208 2.96603 20.0208 3.10417V22.8958Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0729 5.1875H10.9062C9.75565 5.1875 8.82291 6.12024 8.82291 7.27083V9.35417C8.82291 10.5048 9.75565 11.4375 10.9062 11.4375H15.0729C16.2235 11.4375 17.1562 10.5048 17.1562 9.35417V7.27083C17.1562 6.12024 16.2235 5.1875 15.0729 5.1875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesDiary);
export default __webpack_public_path__ + "static/media/notes-diary.3dd5f3da.svg";
export { ForwardRef as ReactComponent };